import { Fragment, useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ButtonModifier } from "../../../components";
import { ShowTableProyekChild } from "../../../components/ShowTable";
import { postRequest } from "../../../constants/api";
import { formatDate } from "../../../constants/helper";
import { Colors } from "../../../constants/styles";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { Box, Button, ButtonGroup, Pagination } from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  buildDetailProyekDeltaPayload,
  hasExistingDetailId,
} from "./detailProyekDelta";

const EXCEL_PREVIEW_ROWS_PER_PAGE = 20;

const TampilProyek = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [focused, setFocused] = useState(false);
  const [kodeProyek, setKodeProyek] = useState("");
  const [tanggalProyek, setTanggalProyek] = useState("");
  const [tanggalProyekDate, setTanggalProyekDate] = useState();
  const [customer, setCustomer] = useState("");
  const [arsitek, setArsitek] = useState("");
  const { id: spreadsheetProyekId } = useParams();

  const [proyeksChildPagination, setProyeksChildPagination] = useState([]);
  const createEmptySpreadsheetRow = () => ({
    id: null,
    clientRowKey: `new-${Date.now()}-${Math.random()}`,
    tglDpDate: null,
    noRab: "",
    pekerjaan: "",
    pekerjaanChild: "",
    ukuran: "",
    satuan: "",
    keterangan: "",
    kirimGambar: "",
    kirimGambarServer: "",
    kirimGambarDate: null,
    kirimGambarDateServer: null,
    kirimGambarMenunggu: false,
    revisi: "",
    revisiDate: null,
    revisiDateServer: null,
    revisiNotes: "",
    revisiNotesServer: "",
    revisiMenunggu: false,
    po: "",
    poDate: null,
    poDateServer: null,
    poNotes: "",
    poNotesServer: "",
    poMenunggu: false,
    masukProduksi: "",
    masukProduksiServer: "",
    masukProduksiDate: null,
    masukProduksiDateServer: null,
    masukProduksiMenunggu: false,
    produksi: "",
    produksiServer: "",
    produksiDate: null,
    produksiDateServer: null,
    produksiMenunggu: false,
  });
  const spreadsheetHeaders = [
    { key: "tglDpDate", label: "TGL DP" },
    { key: "noRab", label: "NO. RAB" },
    { key: "pekerjaan", label: "PEKERJAAN" },
    { key: "pekerjaanChild", label: "SUB PEKERJAAN" },
    { key: "ukuran", label: "UKURAN" },
    { key: "satuan", label: "SATUAN" },
    { key: "keterangan", label: "KETERANGAN" },
    { key: "kirimGambar", label: "KIRIM GBR" },
    { key: "revisi", label: "REVISI GBR / MOCK-UP" },
    { key: "po", label: "PO / ACC GBR" },
    { key: "masukProduksi", label: "MASUK PRODUKSI (ARSITEK KE YESI)" },
    { key: "produksi", label: "PRODUKSI (YESI KE RENDY)" },
  ];
  const [spreadsheetRows, setSpreadsheetRows] = useState([
    createEmptySpreadsheetRow(),
  ]);
  const [dirtyDetailProyekIds, setDirtyDetailProyekIds] = useState([]);
  const [deletedDetailProyekIds, setDeletedDetailProyekIds] = useState([]);
  const [editingDetailRowKeys, setEditingDetailRowKeys] = useState([]);
  const [excelPreviewPage, setExcelPreviewPage] = useState(1);
  const tableContainerRef = useRef(null);
  const topScrollRef = useRef(null);
  const topScrollContentRef = useRef(null);
  const [showTopScroll, setShowTopScroll] = useState(false);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    const topScroll = topScrollRef.current;
    const topScrollContent = topScrollContentRef.current;

    if (!tableContainer || !topScroll || !topScrollContent) {
      return undefined;
    }

    const syncScroll = (source, target) => {
      if (target.scrollLeft !== source.scrollLeft) {
        target.scrollLeft = source.scrollLeft;
      }
    };

    const handleTableScroll = () => syncScroll(tableContainer, topScroll);
    const handleTopScroll = () => syncScroll(topScroll, tableContainer);

    const updateScrollState = () => {
      const totalWidth = tableContainer.scrollWidth;
      topScrollContent.style.width = `${totalWidth}px`;
      const hasOverflow = totalWidth > tableContainer.clientWidth + 1;

      if (topScroll.scrollLeft !== tableContainer.scrollLeft) {
        topScroll.scrollLeft = tableContainer.scrollLeft;
      }

      setShowTopScroll((prev) => {
        if (prev !== hasOverflow) {
          return hasOverflow;
        }
        return prev;
      });
    };

    updateScrollState();

    tableContainer.addEventListener("scroll", handleTableScroll);
    topScroll.addEventListener("scroll", handleTopScroll);
    window.addEventListener("resize", updateScrollState);

    let resizeObserver;
    if (
      typeof window !== "undefined" &&
      typeof window.ResizeObserver !== "undefined"
    ) {
      resizeObserver = new window.ResizeObserver(updateScrollState);
      resizeObserver.observe(tableContainer);
    }

    return () => {
      tableContainer.removeEventListener("scroll", handleTableScroll);
      topScroll.removeEventListener("scroll", handleTopScroll);
      window.removeEventListener("resize", updateScrollState);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [spreadsheetRows]);

  const addSpreadsheetRow = () => {
    setSpreadsheetRows((prevRows) => [
      ...prevRows,
      createEmptySpreadsheetRow(),
    ]);
  };

  const addDirtyDetailProyekId = (id) => {
    if (!hasExistingDetailId(id)) {
      return;
    }

    setDirtyDetailProyekIds((prevIds) =>
      prevIds.includes(id) ? prevIds : [...prevIds, id],
    );
  };

  const getDetailRowKey = (row, rowIndex) =>
    hasExistingDetailId(row.id)
      ? `id-${row.id}`
      : row.clientRowKey || `new-${rowIndex}`;

  const setDetailRowEditing = (row, rowIndex) => {
    const rowKey = getDetailRowKey(row, rowIndex);
    setEditingDetailRowKeys((prevKeys) =>
      prevKeys.includes(rowKey) ? prevKeys : [...prevKeys, rowKey],
    );
  };

  const isDetailRowEditing = (row, rowIndex) =>
    editingDetailRowKeys.includes(getDetailRowKey(row, rowIndex));

  const insertSpreadsheetRowBelow = (rowIndex) => {
    setSpreadsheetRows((prevRows) => {
      const nextRows = [...prevRows];
      const newRow = createEmptySpreadsheetRow();
      nextRows.splice(rowIndex + 1, 0, newRow);
      setEditingDetailRowKeys((prevKeys) => [
        ...prevKeys,
        getDetailRowKey(newRow, rowIndex + 1),
      ]);
      return nextRows;
    });
  };

  const updateSpreadsheetCell = (rowIndex, key, value) => {
    addDirtyDetailProyekId(spreadsheetRows[rowIndex]?.id);
    setSpreadsheetRows((prevRows) =>
      prevRows.map((row, index) =>
        index === rowIndex ? { ...row, [key]: value } : row,
      ),
    );
  };

  const removeSpreadsheetRow = (rowIndex) => {
    setSpreadsheetRows((prevRows) => {
      if (prevRows.length === 1) {
        return prevRows;
      }
      const removedRow = prevRows[rowIndex];
      const removedRowKey = getDetailRowKey(removedRow, rowIndex);
      if (hasExistingDetailId(removedRow?.id)) {
        setDeletedDetailProyekIds((prevIds) =>
          prevIds.includes(removedRow.id)
            ? prevIds
            : [...prevIds, removedRow.id],
        );
        setDirtyDetailProyekIds((prevIds) =>
          prevIds.filter((id) => id !== removedRow.id),
        );
      }
      setEditingDetailRowKeys((prevKeys) =>
        prevKeys.filter((key) => key !== removedRowKey),
      );
      return prevRows.filter((_, index) => index !== rowIndex);
    });
  };

  const navigate = useNavigate();
  let isEditableManager = user.tipeUser !== "ADMIN";
  // let isEditable = isEditableManager;
  let isEditable = true;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");
  const PER_PAGE = 20;

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const handleExcelPreviewPageChange = (_, value) => {
    setExcelPreviewPage(value);
  };

  useEffect(() => {
    getProyekById();
  }, [page]);

  useEffect(() => {
    const maxExcelPreviewPage = Math.max(
      1,
      Math.ceil(spreadsheetRows.length / EXCEL_PREVIEW_ROWS_PER_PAGE),
    );

    setExcelPreviewPage((prevPage) => Math.min(prevPage, maxExcelPreviewPage));
  }, [spreadsheetRows.length]);

  const excelPreviewTotalPages = Math.max(
    1,
    Math.ceil(spreadsheetRows.length / EXCEL_PREVIEW_ROWS_PER_PAGE),
  );
  const excelPreviewStartIndex =
    (excelPreviewPage - 1) * EXCEL_PREVIEW_ROWS_PER_PAGE;
  const visibleExcelPreviewRows = spreadsheetRows.slice(
    excelPreviewStartIndex,
    excelPreviewStartIndex + EXCEL_PREVIEW_ROWS_PER_PAGE,
  );

  const getProyekById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/proyeks/${id}`,
      {},
      navigate,
      dispatch,
    );
    setKodeProyek(response.data.kodeProyek);
    setTanggalProyek(formatDate(response.data.tanggalProyek));
    setTanggalProyekDate(new Date(response.data.tanggalProyek));
    setCustomer(response.data.customer);
    setArsitek(
      `${response.data.arsitek.kodeArsitek} - ${response.data.arsitek.namaArsitek}`,
    );

    const response2 = await postRequest(
      `/proyekByIdForAllDetail/${id}`,
      {},
      navigate,
      dispatch,
    );
    setProyeksChildPagination(response2.data);

    const getDetailProyeks = await postRequest(
      `/detailProyeksByProyekId/${id}`,
      {},
      navigate,
      dispatch,
    );

    const toISOorNull = (v) => (v ? new Date(v) : null);

    const mapDetailToRow = (d) => ({
      id: d.id ?? "",
      clientRowKey: `id-${d.id}`,
      tglDpDate: toISOorNull(d.tglDpDate),
      noRab: d.noRab ?? "",
      pekerjaan: d.pekerjaan ?? "",
      pekerjaanChild: d.pekerjaanChild ?? "",
      ukuran: d.ukuran ?? null,
      satuan: d.satuan ?? "",
      keterangan: d.keterangan ?? "",

      kirimGambar: d.kirimGambar ?? null,
      kirimGambarServer: d.kirimGambar ?? null,
      kirimGambarDate: toISOorNull(d.kirimGambarDate),
      kirimGambarDateServer: toISOorNull(d.kirimGambarDate),
      kirimGambarMenunggu: !!d.kirimGambarMenunggu,

      revisi: d.revisi ?? "",
      revisiServer: d.revisi ?? "",
      revisiDate: toISOorNull(d.revisiDate),
      revisiDateServer: toISOorNull(d.revisiDate),
      revisiNotes: d.revisiNotes ?? "",
      revisiNotesServer: d.revisiNotes ?? "",
      revisiMenunggu: !!d.revisiMenunggu,

      po: d.po ?? "",
      poServer: d.po ?? "",
      poDate: toISOorNull(d.poDate),
      poDateServer: toISOorNull(d.poDate),
      poNotes: d.poNotes ?? "",
      poNotesServer: d.poNotes ?? "",
      poMenunggu: !!d.poMenunggu,

      masukProduksi: d.masukProduksi ?? "",
      masukProduksiServer: d.masukProduksi ?? "",
      masukProduksiDate: toISOorNull(d.masukProduksiDate),
      masukProduksiDateServer: toISOorNull(d.masukProduksiDate),
      masukProduksiMenunggu: !!d.masukProduksiMenunggu,

      produksi: d.produksi ?? "",
      produksiServer: d.produksi ?? "",
      produksiDate: toISOorNull(d.produksiDate),
      produksiDateServer: toISOorNull(d.produksiDate),
      produksiMenunggu: !!d.produksiMenunggu,
      createdAt: new Date(
        new Date(d.createdAt).setDate(new Date(d.createdAt).getDate() + 1),
      ),
      updatedAt: new Date(
        new Date(d.updatedAt).setDate(new Date(d.updatedAt).getDate() + 1),
      ),
    });

    if (getDetailProyeks.data.length > 0) {
      const rows = getDetailProyeks.data.map(mapDetailToRow);
      console.log("rows");
      console.log(rows);
      setSpreadsheetRows(rows); // single state update
    } else {
      setSpreadsheetRows([createEmptySpreadsheetRow()]);
    }
    setDirtyDetailProyekIds([]);
    setDeletedDetailProyekIds([]);
    setEditingDetailRowKeys([]);

    setLoading(false);
  };

  const deleteProyek = async (id) => {
    setLoading(true);
    await postRequest(`/deleteProyek/${id}`, {}, navigate, dispatch);
    navigate("/daftarProyek");
    setLoading(false);
  };

  const saveDetailProyek = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      await postRequest(
        `/transaksiDetailProyekDelta`,
        buildDetailProyekDeltaPayload({
          spreadsheetRows,
          dirtyDetailProyekIds,
          deletedDetailProyekIds,
          spreadsheetProyekId,
          kodeProyek,
          tanggalProyekDate,
        }),
        navigate,
        dispatch,
      );
      getProyekById();
      setLoading(false);
    } else {
      alert("Error!");
      // setError(true);
      // setOpen(!open);
    }
  };

  const getSpreadsheetExcelCellData = (column, row) => {
    let returnKirimGambar = "";
    if (row.kirimGambar) {
      returnKirimGambar += `(${row.kirimGambar}) : `;
    }
    if (row.kirimGambarDate) {
      returnKirimGambar += `${formatDate(row?.kirimGambarDate)}`;
    }

    let returnRevisi = "";
    if (row.revisi) {
      returnRevisi += `(${row.revisi}) : `;
    }
    if (row.revisiDate) {
      returnRevisi += `${formatDate(row?.revisiDate)} : `;
    }
    if (row.revisiNotes) {
      returnRevisi += `${row.revisiNotes}`;
    }

    let returnPo = "";
    if (row.po) {
      returnPo += `(${row.po}) : `;
    }
    if (row.poDate) {
      returnPo += `${formatDate(row?.poDate)} : `;
    }
    if (row.poNotes) {
      returnPo += `${row.poNotes}`;
    }

    let returnMasukProduksi = "";
    if (row.masukProduksiDate) {
      returnMasukProduksi += `${formatDate(row?.masukProduksiDate)} : `;
    }
    if (row.masukProduksi) {
      returnMasukProduksi += `${row.masukProduksi}`;
    }

    let returnProduksi = "";
    if (row.produksiDate) {
      returnProduksi += `${formatDate(row?.produksiDate)} : `;
    }
    if (row.produksi) {
      returnProduksi += `${row.produksi}`;
    }

    switch (column.key) {
      case "tglDpDate":
        return {
          value: row.tglDpDate ? formatDate(row.tglDpDate) : "",
        };
      case "noRab":
        return { value: row.noRab };
      case "pekerjaan":
        return { value: row.pekerjaan };
      case "pekerjaanChild":
        return { value: row.pekerjaanChild };
      case "ukuran":
        return { value: row.ukuran };
      case "keterangan":
        return { value: row.keterangan };
      case "kirimGambar":
        return {
          value: returnKirimGambar,
          backgroundColor: row?.kirimGambarMenunggu ? "#ffff66" : undefined,
        };
      case "revisi":
        return {
          value: returnRevisi,
          backgroundColor: row?.revisiMenunggu ? "pink" : undefined,
        };
      case "po":
        return {
          value: returnPo,
          backgroundColor: row?.poMenunggu ? "pink" : undefined,
        };
      case "masukProduksi":
        return {
          value: returnMasukProduksi,
          backgroundColor: row?.masukProduksiMenunggu ? "#ffff66" : undefined,
        };
      case "produksi":
        return {
          value: returnProduksi,
          backgroundColor: row?.produksiMenunggu ? "#99ff99" : undefined,
        };
      default:
        return { value: row[column.key] };
    }
  };

  const escapeHtml = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const downloadExcel = () => {
    const tableHeaderRows = `
      <tr>
        <th colspan="3" style="border: 1px solid black;">PROYEK</th>
        <th colspan="5" style="border: 1px solid black;">PEKERJAAN</th>
        <th colspan="5" style="border: 1px solid black;">TANGGAL</th>
      </tr>
      <tr>
        <th style="border: 1px solid black;">NO.</th>
        ${spreadsheetHeaders
          .map(
            (column) =>
              `<th style="border: 1px solid black;">${escapeHtml(
                column.label,
              )}</th>`,
          )
          .join("")}
      </tr>
    `;

    const tableRows = spreadsheetRows
      .map(
        (row, rowIndex) => `
          <tr>
            <td style="border: 1px solid black;">${rowIndex + 1}</td>
            ${spreadsheetHeaders
              .map((column) => {
                const cell = getSpreadsheetExcelCellData(column, row);
                const backgroundColor = cell.backgroundColor
                  ? `background-color: ${cell.backgroundColor};`
                  : "";
                return `<td style="border: 1px solid black; ${backgroundColor}">${escapeHtml(
                  cell.value,
                )}</td>`;
              })
              .join("")}
          </tr>
        `,
      )
      .join("");

    const excelContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8" />
        </head>
        <body>
          <table>${tableHeaderRows}${tableRows}</table>
        </body>
      </html>
    `;

    const blob = new Blob([excelContent], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Proyek-${kodeProyek || id}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const renderSpreadsheetCellReadOnly = (column, row) => {
    const cell = getSpreadsheetExcelCellData(column, row);

    return (
      <div
        className="detail-readonly-cell"
        style={{
          backgroundColor: cell.backgroundColor,
        }}
      >
        {cell.value || "-"}
      </div>
    );
  };

  const renderSpreadsheetCell = (column, row, rowIndex) => {
    const todayZero = new Date();
    todayZero.setHours(0, 0, 0, 0);

    let isKirimGambarDateDisabled = false;
    if (row.kirimGambarDateServer !== null) {
      if (
        row.kirimGambarDateServer < todayZero &&
        user.tipeUser === "ARSITEK"
      ) {
        isKirimGambarDateDisabled = true;
      }
    }

    let isRevisiDateDisabled = false;
    if (row.revisiDateServer !== null) {
      if (row.revisiDateServer < todayZero && user.tipeUser === "ARSITEK") {
        isRevisiDateDisabled = true;
      }
    }

    let isPoDateDisabled = false;
    if (row.poDateServer !== null) {
      if (row.poDateServer < todayZero && user.tipeUser === "ARSITEK") {
        isPoDateDisabled = true;
      }
    }

    let isMasukProduksiDateDisabled = false;
    if (row.masukProduksiDateServer !== null) {
      if (
        row.masukProduksiDateServer < todayZero &&
        user.tipeUser === "ARSITEK"
      ) {
        isMasukProduksiDateDisabled = true;
      }
    }

    let isProduksiDateDisabled = false;
    if (row.produksiDateServer !== null) {
      if (row.produksiDateServer < todayZero && user.tipeUser === "ARSITEK") {
        isProduksiDateDisabled = true;
      }
    }

    switch (column.key) {
      case "tglDpDate":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <DatePicker
              selected={row.tglDpDate}
              placeholderText={focused ? "TGL DP" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(date) =>
                updateSpreadsheetCell(rowIndex, "tglDpDate", date)
              }
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm detail-control"
              disabled={
                row.createdAt < new Date() &&
                user.tipeUser === "ARSITEK" &&
                true
              }
            />
          </div>
        );
      case "noRab":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <Form.Control
              value={row.noRab}
              placeholder={focused ? column.label : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(rowIndex, "noRab", event.target.value)
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={3}
              disabled={
                row.createdAt < new Date() &&
                user.tipeUser === "ARSITEK" &&
                true
              }
            />
          </div>
        );
      case "pekerjaan":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <Form.Control
              value={row.pekerjaan}
              placeholder={focused ? column.label : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(rowIndex, "pekerjaan", event.target.value)
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={3}
              disabled={
                row.createdAt < new Date() &&
                user.tipeUser === "ARSITEK" &&
                true
              }
            />
          </div>
        );
      case "pekerjaanChild":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <Form.Control
              value={row.pekerjaanChild}
              placeholder={focused ? column.label : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "pekerjaanChild",
                  event.target.value,
                )
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={3}
              disabled={
                row.createdAt < new Date() &&
                user.tipeUser === "ARSITEK" &&
                true
              }
            />
          </div>
        );
      case "ukuran":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <NumericFormat
              value={row.ukuran ?? ""}
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2} // number of decimal places allowed
              allowNegative={false} // optional
              allowLeadingZeros={false} // optional
              customInput={Form.Control}
              size="sm"
              className="detail-control"
              style={detailControlStyle}
              placeholder={focused ? column.label : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onValueChange={(values) => {
                updateSpreadsheetCell(
                  rowIndex,
                  "ukuran",
                  values.floatValue ?? 0, // directly get numeric value
                );
              }}
              disabled={
                row.createdAt < new Date() &&
                user.tipeUser === "ARSITEK" &&
                true
              }
            />

            {/* <NumericFormat
              value={row.ukuran ?? ""}
              decimalSeparator={","}
              thousandSeparator={"."}
              customInput={Form.Control}
              size="sm"
              className="detail-control"
              style={detailControlStyle}
              placeholder={focused ? column.label : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onValueChange={(values) => {
                updateSpreadsheetCell(
                  rowIndex,
                  "ukuran",
                  values.formattedValue.split(".").join("").replace(/,/g, "")
                );
              }}
              disabled={
                row.createdAt < new Date() &&
                user.tipeUser === "ARSITEK" &&
                true
              }
            /> */}
          </div>
        );
      case "keterangan":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <Form.Control
              value={row.keterangan}
              placeholder={focused ? column.label : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "keterangan",
                  event.target.value,
                )
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={3}
              disabled={
                row.createdAt < new Date() &&
                user.tipeUser === "ARSITEK" &&
                true
              }
            />
          </div>
        );
      case "kirimGambar":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <NumericFormat
              value={row.kirimGambar ?? ""}
              decimalSeparator={","}
              thousandSeparator={"."}
              customInput={Form.Control}
              size="sm"
              className="detail-control"
              style={detailControlStyle}
              placeholder={focused ? "NO. KIRIM GBR" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onValueChange={(values) => {
                updateSpreadsheetCell(
                  rowIndex,
                  "kirimGambar",
                  values.formattedValue.split(".").join("").replace(/,/g, ""),
                );
              }}
              disabled={isKirimGambarDateDisabled}
            />
            <DatePicker
              selected={row.kirimGambarDate}
              placeholderText={focused ? "TGL. KIRIM GBR" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(date) =>
                updateSpreadsheetCell(rowIndex, "kirimGambarDate", date)
              }
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm detail-control"
              disabled={isKirimGambarDateDisabled}
            />
            <Form.Check
              type="checkbox"
              id={`kirimGambar-menunggu-${rowIndex}`}
              label="Menunggu"
              checked={row.kirimGambarMenunggu}
              className="detail-checkbox"
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "kirimGambarMenunggu",
                  event.target.checked,
                )
              }
            />
          </div>
        );
      case "revisi":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <Form.Control
              value={row.revisi}
              placeholder={focused ? "NO. REV" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(rowIndex, "revisi", event.target.value)
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              disabled={isRevisiDateDisabled}
            />
            <DatePicker
              selected={row.revisiDate}
              placeholderText={focused ? "TGL. REV" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(date) =>
                updateSpreadsheetCell(rowIndex, "revisiDate", date)
              }
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm detail-control"
              disabled={isRevisiDateDisabled}
            />
            <Form.Control
              value={row.revisiNotes}
              placeholder={focused ? "KET. REV" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "revisiNotes",
                  event.target.value,
                )
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={2}
              disabled={isRevisiDateDisabled}
            />
            <Form.Check
              type="checkbox"
              id={`revisi-menunggu-${rowIndex}`}
              label="Menunggu"
              checked={row.revisiMenunggu}
              className="detail-checkbox"
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "revisiMenunggu",
                  event.target.checked,
                )
              }
            />
          </div>
        );
      case "po":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <Form.Control
              value={row.po}
              placeholder={focused ? "NO. PO" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(rowIndex, "po", event.target.value)
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              disabled={isPoDateDisabled}
            />
            <DatePicker
              selected={row.poDate}
              placeholderText={focused ? "TGL. PO" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(date) =>
                updateSpreadsheetCell(rowIndex, "poDate", date)
              }
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm detail-control"
              disabled={isPoDateDisabled}
            />
            <Form.Control
              value={row.poNotes}
              placeholder={focused ? "KET. PO" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(rowIndex, "poNotes", event.target.value)
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={2}
              disabled={isPoDateDisabled}
            />
            <Form.Check
              type="checkbox"
              id={`po-menunggu-${rowIndex}`}
              label="Menunggu"
              checked={row.poMenunggu}
              className="detail-checkbox"
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "poMenunggu",
                  event.target.checked,
                )
              }
            />
          </div>
        );
      case "masukProduksi":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <DatePicker
              selected={row.masukProduksiDate}
              placeholderText={focused ? "TGL. MS PROD" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(date) =>
                updateSpreadsheetCell(rowIndex, "masukProduksiDate", date)
              }
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm detail-control"
              disabled={isMasukProduksiDateDisabled}
            />
            <Form.Control
              value={row.masukProduksi}
              placeholder={focused ? "KET. MS PROD" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "masukProduksi",
                  event.target.value,
                )
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={2}
              disabled={isMasukProduksiDateDisabled}
            />
            <Form.Check
              type="checkbox"
              id={`masuk-produksi-menunggu-${rowIndex}`}
              label="Menunggu"
              checked={row.masukProduksiMenunggu}
              className="detail-checkbox"
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "masukProduksiMenunggu",
                  event.target.checked,
                )
              }
            />
          </div>
        );
      case "produksi":
        return (
          <div className="d-flex flex-column detail-field-stack">
            <DatePicker
              selected={row.produksiDate}
              placeholderText={focused ? "TGL. PROD" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(date) =>
                updateSpreadsheetCell(rowIndex, "produksiDate", date)
              }
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm detail-control"
              disabled={isProduksiDateDisabled}
            />
            <Form.Control
              value={row.produksi}
              placeholder={focused ? "KET. PROD" : ""}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              onChange={(event) =>
                updateSpreadsheetCell(rowIndex, "produksi", event.target.value)
              }
              size="sm"
              className="detail-control"
              style={uppercaseDetailControlStyle}
              as="textarea"
              rows={2}
              disabled={isProduksiDateDisabled}
            />
            <Form.Check
              type="checkbox"
              id={`produksi-menunggu-${rowIndex}`}
              label="Menunggu"
              checked={row.produksiMenunggu}
              className="detail-checkbox"
              onChange={(event) =>
                updateSpreadsheetCell(
                  rowIndex,
                  "produksiMenunggu",
                  event.target.checked,
                )
              }
            />
          </div>
        );
      default:
        return (
          <Form.Control
            value={row[column.key]}
            placeholder={focused ? column.label : ""}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={(event) =>
              updateSpreadsheetCell(rowIndex, column.key, event.target.value)
            }
            size="sm"
            className="detail-control"
            style={uppercaseDetailControlStyle}
            disabled={
              row.createdAt < new Date() && user.tipeUser === "ARSITEK" && true
            }
          />
        );
    }
  };
  const renderSpreadsheetCellExcel = (column, row) => {
    const cell = getSpreadsheetExcelCellData(column, row);

    return (
      <td
        style={{
          backgroundColor: cell.backgroundColor,
          border: "1px solid black",
        }}
      >
        {cell.value}
      </td>
    );
  };

  return (
    <Container fluid className="detail-proyek-container">
      <h3>Proyekan</h3>
      <h5 style={{ fontWeight: 400 }}>Proyek</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarProyek")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarProyek/proyek/${id}/edit`}
              deleteUser={deleteProyek}
              nameUser={kodeProyek}
            />
          </>
        )}
      </Box>

      <Form>
        <Card>
          <Card.Header>Proyek</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Bukti :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={kodeProyek}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Proyek :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tanggalProyek}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Customer :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={`${customer.kodeCustomer} - ${customer.namaCustomer}`}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Arsitek :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={arsitek} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
      <Card className="mt-4 detail-proyek-card">
        <Card.Header>Detail Proyek</Card.Header>
        <Card.Body>
          <Form noValidate onSubmit={saveDetailProyek}>
            <div
              className="detail-proyek-table-top-scroll"
              ref={topScrollRef}
              style={{ display: showTopScroll ? "block" : "none" }}
            >
              <div
                className="detail-proyek-table-scroll-spacer"
                ref={topScrollContentRef}
              />
            </div>
            <div
              className="table-responsive detail-proyek-table-wrapper"
              ref={tableContainerRef}
            >
              <Table
                bordered
                hover
                size="sm"
                className="detail-proyek-table"
                style={detailTableStyle}
              >
                <thead>
                  <tr>
                    <th colSpan={3} style={tableHeader}>
                      PROYEK
                    </th>
                    <th colSpan={5} style={tableHeader}>
                      PEKERJAAN
                    </th>
                    <th colSpan={6} style={tableHeader}>
                      TANGGAL
                    </th>
                  </tr>
                  <tr>
                    <th style={tableHeader}>NO.</th>
                    {spreadsheetHeaders.map((column) => (
                      <th key={column.key} style={tableHeader}>
                        {column.label}
                      </th>
                    ))}
                    <th style={tableHeader}>AKSI</th>
                  </tr>
                </thead>
                <tbody style={{ backgroundColor: Colors.grey300 }}>
                  {spreadsheetRows.map((row, rowIndex) => {
                    const rowEditing = isDetailRowEditing(row, rowIndex);

                    return (
                      <tr
                        key={`spreadsheet-row-${getDetailRowKey(
                          row,
                          rowIndex,
                        )}`}
                      >
                        <td>{rowIndex + 1}</td>
                        {spreadsheetHeaders.map((column) => (
                          <td
                            key={`${column.key}-${getDetailRowKey(
                              row,
                              rowIndex,
                            )}`}
                          >
                            {rowEditing
                              ? renderSpreadsheetCell(column, row, rowIndex)
                              : renderSpreadsheetCellReadOnly(column, row)}
                          </td>
                        ))}
                        <td>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 0.75,
                              flexWrap: "nowrap",
                              alignItems: "center",
                              "& .MuiButton-root": {
                                borderRadius: "999px",
                                fontSize: "0.72rem",
                                fontWeight: 600,
                                minHeight: 28,
                                minWidth: "auto",
                                px: 1.1,
                                py: 0.25,
                                textTransform: "none",
                                whiteSpace: "nowrap",
                              },
                            }}
                          >
                            {!rowEditing && (
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                startIcon={<EditOutlinedIcon />}
                                onClick={() =>
                                  setDetailRowEditing(row, rowIndex)
                                }
                              >
                                Edit
                              </Button>
                            )}
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              startIcon={<AddIcon />}
                              onClick={() =>
                                insertSpreadsheetRowBelow(rowIndex)
                              }
                            >
                              Sisip Baris
                            </Button>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              startIcon={<DeleteOutlineIcon />}
                              onClick={() => removeSpreadsheetRow(rowIndex)}
                              disabled={spreadsheetRows.length === 1}
                            >
                              Hapus
                            </Button>
                          </Box>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap",
                gap: 1,
                alignItems: "center",
                mt: 2,
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{ fontSize: "0.85rem", px: 3, py: 0.75 }}
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {/* <div style={{ marginTop: "20px" }}>
        <Chip
          label="Kirim Gambar"
          sx={{
            backgroundColor: Colors.blue300,
          }}
        />
        <Chip
          label="Revisi"
          sx={{
            backgroundColor: Colors.red400,
          }}
        />
        <Chip
          label="PO"
          sx={{
            backgroundColor: Colors.yellow400,
          }}
        />
        <Chip
          label="Produksi"
          sx={{
            backgroundColor: Colors.green400,
          }}
        />
      </div>
      <Box sx={tableContainer}>
        <ShowTableProyekChild
          page={page}
          limit={limit}
          id={id}
          currentPosts={proyeksChildPagination}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box> */}

      <Card className="mt-4 detail-proyek-card">
        <Card.Header>Cetak Excel</Card.Header>
        <Card.Body>
          <div style={{ marginTop: "10px" }}>
            <ButtonGroup variant="outlined" color="secondary">
              <Button startIcon={<SearchIcon />} onClick={downloadExcel}>
                Excel
              </Button>
            </ButtonGroup>
          </div>
          <div
            id="content"
            className="detail-proyek-excel-preview-wrapper"
            style={pdfContainer}
          >
            <div>
              <table className="styled-table">
                <thead>
                  <tr>
                    <th colSpan={3} style={{ border: "1px solid black" }}>
                      PROYEK
                    </th>
                    <th colSpan={5} style={{ border: "1px solid black" }}>
                      PEKERJAAN
                    </th>
                    <th colSpan={5} style={{ border: "1px solid black" }}>
                      TANGGAL
                    </th>
                  </tr>
                  <tr>
                    <th style={{ border: "1px solid black" }}>NO.</th>
                    {spreadsheetHeaders.map((column) => (
                      <th
                        key={column.key}
                        style={{ border: "1px solid black" }}
                      >
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {visibleExcelPreviewRows.map((row, rowIndex) => {
                    const globalRowIndex = excelPreviewStartIndex + rowIndex;

                    return (
                      <tr key={`excel-preview-row-${globalRowIndex}`}>
                        <td style={{ border: "1px solid black" }}>
                          {globalRowIndex + 1}
                        </td>
                        {spreadsheetHeaders.map((column) => (
                          <Fragment
                            key={`excel-${column.key}-${globalRowIndex}`}
                          >
                            {renderSpreadsheetCellExcel(column, row)}
                          </Fragment>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <Box
            className="detail-proyek-pagination-bar"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
              mt: 2,
            }}
          >
            <Box sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
              Preview {excelPreviewStartIndex + 1}-
              {Math.min(
                excelPreviewStartIndex + EXCEL_PREVIEW_ROWS_PER_PAGE,
                spreadsheetRows.length,
              )}{" "}
              dari {spreadsheetRows.length} baris. File Excel tetap berisi semua
              baris.
            </Box>
            <Pagination
              count={excelPreviewTotalPages}
              page={excelPreviewPage}
              onChange={handleExcelPreviewPageChange}
              color="primary"
              size={screenSize <= 600 ? "small" : "medium"}
            />
          </Box>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilProyek;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const detailTableStyle = {
  minWidth: "1400px",
};

const detailControlStyle = {
  fontSize: "0.75rem",
  padding: "0.35rem 0.5rem",
};

const uppercaseDetailControlStyle = {
  ...detailControlStyle,
  textTransform: "uppercase",
};

const tableHeader = {
  textAlign: "center",
  color: "white",
  backgroundColor: Colors.blue700,
  fontSize: "0.75rem",
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
  fontWeight: 600,
};
